<template>
    <div class="content my_data create_report_step if-profile edit_myData px-4">
        <md-button class="md-raised md-info md-round m-0" @click="chooseInputFormat()">
            Upload
        </md-button>
        <md-button class="ml-30 mt-0 mr-0 mb-0 md-raised md-info md-round">
            <a :href="pathToDownload" @click.prevent="downloadFile(pathToDownload)" class="href-white">
                <label for="input-file-csv">Download CSV Template</label>
            </a>
        </md-button>
        <input id="input-file-csv" type="file" ref="csvInput" accept=".csv" @change="fileSelected" style="display: none" />
    </div>
</template>
<script>
import { mapActions} from 'vuex';
import axios from 'axios';
export default {
    name: 'UploadMyData',  
    data() {
        return {
            dataSource: [],           
            createData: {},
            reportData: [],
            reportType: {},
            data: {}, 
            years: null,  
            params: {},
            pathToDownload: window.location.origin + '/templates/my-data.csv',      
        };
    },
    async mounted() {
        this.reportType = await this.checkReport(true);
        this.years = await this.checkYear();
       
    },
    methods: {
        ...mapActions({
            save: 'user/saveReport', 
            alertSuccess: 'alerts/success',          
        }),
        downloadFile(file) {
            axios.get(file, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'text/csv' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'my-data.csv'
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch()
        },
        checkYear(){
            switch(this.checkReport(false)){
                case 'imr': return this.$store.getters['user/market_report'].data.years.length;
                case 'if': return this.$store.getters['user/financial_report'].years.length;
                case 'valuation_main': return this.$store.getters['user/vestimate_report'].data.years.length;
                case 'company': return 1;
            }
        },
        checkReport(isReport) {
            if (this.$route.path.includes('finan'))
                return isReport?'financial':'if';
            else if (this.$route.path.includes('market'))
                return isReport ? 'market' : 'imr';
            else if (this.$route.path.includes('company'))
                return 'company';
            else if (this.$route.path.includes('valuation'))
                return isReport ? 'valuation' : 'valuation_main';
        },
        saveMarket: function (csvData){
            let annualSales = this.getCSVData(csvData, 6);
            let employment = this.getCSVData(csvData, 38);
            let averageAnnualWage = this.getCSVData(csvData, 39);
            let rent = this.getCSVData(csvData, 11);
          
            for(let i = 0;i<this.years;i++){
                this.dataSource[`sales_${i}`] = annualSales[i];
                this.dataSource[`avg_wage_${i}`] = averageAnnualWage[i];
                this.dataSource[`employment_${i}`] = employment[i];
                this.dataSource[`rent_${i}`] = rent[i];
            }
            this.saveInputs()
        },
        saveCompany: function (csvData) {

            this.params = {
                acc_receivable: this.getCSVData(csvData, 26)[0],
                other_netSales: this.getCSVData(csvData, 6)[0],
                other_grossProfit: this.getCSVData(csvData, 8)[0],
                other_offcomp: this.getCSVData(csvData, 9)[0],
                other_amortization: this.getCSVData(csvData, 18)[0],
                avg_annual_wage: this.getCSVData(csvData, 39)[0],
                ft_emps: this.getCSVData(csvData, 38)[0],
                liability_accountsPayable: this.getCSVData(csvData, 34)[0],
                liability_otherCurrent: parseInt(this.getCSVData(csvData, 34)[0]) + parseInt(this.getCSVData(csvData, 35)[0]) + parseInt(this.getCSVData(csvData, 36)[0]),
                liability_longTermDebt: this.getCSVData(csvData, 37)[0],
                asset_otherCurrent: parseInt(this.getCSVData(csvData, 25)[0]) + parseInt(this.getCSVData(csvData, 26)[0]) + parseInt(this.getCSVData(csvData, 27)[0]) + parseInt(this.getCSVData(csvData, 28)[0]),
                totalAssets: parseInt(this.getCSVData(csvData, 25)[0]) + parseInt(this.getCSVData(csvData, 26)[0]) + parseInt(this.getCSVData(csvData, 27)[0]) + parseInt(this.getCSVData(csvData, 28)[0]) + parseInt(this.getCSVData(csvData, 31)[0]) + parseInt(this.getCSVData(csvData, 32)[0]),
                op_expenses: parseInt(this.getCSVData(csvData, 9)[0]) + parseInt(this.getCSVData(csvData, 10)[0]) + parseInt(this.getCSVData(csvData, 11)[0]) + parseInt(this.getCSVData(csvData, 12)[0]) + parseInt(this.getCSVData(csvData, 13)[0]) + parseInt(this.getCSVData(csvData, 14)[0]) + parseInt(this.getCSVData(csvData, 15)[0]) + parseInt(this.getCSVData(csvData, 16)[0]) + parseInt(this.getCSVData(csvData, 17)[0]) + parseInt(this.getCSVData(csvData, 18)[0]),
                net_profit: parseInt(this.getCSVData(csvData, 8)[0]) - parseInt(this.getCSVData(csvData, 9)[0]) - parseInt(this.getCSVData(csvData, 10)[0]) - parseInt(this.getCSVData(csvData, 11)[0]) - parseInt(this.getCSVData(csvData, 12)[0]) - parseInt(this.getCSVData(csvData, 13)[0]) - parseInt(this.getCSVData(csvData, 14)[0]) - parseInt(this.getCSVData(csvData, 15)[0]) - parseInt(this.getCSVData(csvData, 16)[0]) - parseInt(this.getCSVData(csvData, 17)[0]) - parseInt(this.getCSVData(csvData, 18)[0]) + parseInt(this.getCSVData(csvData, 19)[0]) - parseInt(this.getCSVData(csvData, 20)[0]) + parseInt(this.getCSVData(csvData, 21)[0])
            }
            this.saveInputs()
        },
        saveFinancial: function (csvData) {
            let revenue = this.getCSVData(csvData, 6);
            let cost_sales = this.getCSVData(csvData, 7);
            let gross_margin = this.getCSVData(csvData, 8);
            let officers_compensation = this.getCSVData(csvData, 9);
            let salary_wages = this.getCSVData(csvData, 10);
            let rent = this.getCSVData(csvData, 11);
            let taxes_paid = this.getCSVData(csvData, 12);
            let advertising = this.getCSVData(csvData, 13);
            let benefitsPension = this.getCSVData(csvData, 14);
            let repairs = this.getCSVData(csvData, 15);
            let badDebts = this.getCSVData(csvData, 16);
            let salesGeneralAdmin = this.getCSVData(csvData, 17);
            let depreciation = this.getCSVData(csvData, 18);
            let interest_income = this.getCSVData(csvData, 19);
            let interest_expense = this.getCSVData(csvData, 20);
            let other_income = this.getCSVData(csvData, 21);
            let income_text = this.getCSVData(csvData, 22);            
            let cash = this.getCSVData(csvData, 25);
            let accounts_receivable = this.getCSVData(csvData, 26);
            let inventory = this.getCSVData(csvData, 27);
            let otherCurrentAssets = this.getCSVData(csvData, 28);
            let grossFixedAssets = this.getCSVData(csvData, 29);
            let accumDepreciations = this.getCSVData(csvData, 30);
            let netFixedAssets = this.getCSVData(csvData, 31);
            let otherNonCurrentAssets = this.getCSVData(csvData, 32);
            let accounts_payable = this.getCSVData(csvData, 34);
            let loan_notes_payable = this.getCSVData(csvData, 35);
            let current_liabilties = this.getCSVData(csvData, 36);
            let long_term_liabilities = this.getCSVData(csvData, 37);
            let ft_emps = this.getCSVData(csvData, 38);
            let avg_annual_wage = this.getCSVData(csvData, 39);

            for (let i = 0; i < this.years; i++) {
                this.dataSource[`other_repairs_field_${i}`] = repairs[i];
                this.dataSource[`other_netSales_field_${i}`] = revenue[i];
                this.dataSource[`cosl_field_${i}`] = cost_sales[i];
                this.dataSource[`other_grossProfit_field_${i}`] = gross_margin[i];
                this.dataSource[`other_offcomp_field_${i}`] = officers_compensation[i];
                this.dataSource[`other_payroll_field_${i}`] = salary_wages[i];
                this.dataSource[`other_rent_field_${i}`] = rent[i];
                this.dataSource[`other_taxes_field_${i}`] = taxes_paid[i];
                this.dataSource[`other_advertising_field_${i}`] = advertising[i];
                this.dataSource[`other_benefits_field_${i}`] = benefitsPension[i];
                this.dataSource[`other_baddebt_field_${i}`] = badDebts[i];
                this.dataSource[`other_other_field_${i}`] = salesGeneralAdmin[i];
                this.dataSource[`other_amortization_field_${i}`] = depreciation[i];
                this.dataSource[`other_interestincome_field_${i}`] = interest_income[i];
                this.dataSource[`other_interest_field_${i}`] = interest_expense[i];
                this.dataSource[`other_otherincome_field_${i}`] = other_income[i];
                this.dataSource[`income_tax_field_${i}`] = income_text[i];
                this.dataSource[`asset_cash_field_${i}`] = cash[i];
                this.dataSource[`asset_accountsReceivable_field_${i}`] = accounts_receivable[i];
                this.dataSource[`asset_inventory_field_${i}`] = inventory[i];
                this.dataSource[`asset_otherCurrent_field_${i}`] = otherCurrentAssets[i];
                this.dataSource[`asset_gross_fixed_field_${i}`] = grossFixedAssets[i];
                this.dataSource[`asset_depreciation_amortization_depletion_field_${i}`] = accumDepreciations[i];
                this.dataSource[`asset_fixed_field_${i}`] = netFixedAssets[i];
                this.dataSource[`asset_otherNonCurrent_field_${i}`] = otherNonCurrentAssets[i];
                this.dataSource[`liability_accountsPayable_field_${i}`] = accounts_payable[i];
                this.dataSource[`liability_loans_field_${i}`] = loan_notes_payable[i];
                this.dataSource[`liability_otherCurrent_field_${i}`] = current_liabilties[i];
                this.dataSource[`liability_longTermDebt_field_${i}`] = long_term_liabilities[i];
                this.dataSource[`ft_emps_field_${i}`] = ft_emps[i];
                this.dataSource[`avg_annual_wage${i}`] = avg_annual_wage[i];
                this.dataSource[`liability_netWorth_field_${i}`] = 0;
                this.dataSource[`other_cosl_field_${i}`] = 0;
                this.dataSource[`other_homeoffice_field_${i}`] = 0;
                this.dataSource[`other_insurance_field_${i}`] = 0;
                this.dataSource[`other_netProfit_field_${i}`] = 0;
                this.dataSource[`other_insurance_field_${i}`] = 0;
                this.dataSource[`other_workingCapital_field_${i}`] = 0;
                
            }
        this.dataSource['accounts_payable_business_revenue_check'] = true;
        this.dataSource['ebitda_business_revenue_check']= true;
        this.dataSource['current_ratio_check'] = true;
        this.dataSource['return_on_assets_check'] = true;
        this.dataSource['quick_ratio_check'] = true;
        this.dataSource['return_on_net_worth_check'] = true;
        this.dataSource['days_payable_check'] = true;
        this.dataSource['return_on_business_revenue_check'] = true;
        this.dataSource['current_liabilities_inventory_check'] = true;
        this.dataSource['discretionary_owner_earnings_check'] = true;
        this.dataSource['net_working_capital_check'] = true;
        this.dataSource['return_on_assets_after_tax_check'] = true;
        this.dataSource['cosPayables_check'] = true;
        this.dataSource['return_on_net_worth_after_tax_check'] = true;
        this.dataSource['cosInventory_check'] = true;
        this.dataSource['return_on_business_revenue_after_tax_check'] = true;
        this.dataSource['profit_employee_check'] = true;
        this.dataSource['owner_earnings_employee_check'] = true;
        this.dataSource['assets_business_revenue_check'] = true;
        this.dataSource['interest_coverage_check'] = true;
        this.dataSource['days_inventory_check'] = true;
        this.dataSource['current_liabilities_net_worth_check'] = true;
        this.dataSource['days_receivables_check'] = true;
        this.dataSource['long_term_liabilities_net_worth_check'] = true;
        this.dataSource['current_asset_turnover_check'] = true;
        this.dataSource['loans_notes_payable_net_worth_check'] = true;
        this.dataSource['fixed_asset_turnover_check'] = true;
        this.dataSource['zscore_check'] = true;
        this.dataSource['gross_margin_business_revenue_check'] = true;
        this.dataSource['total_liabilities_net_worth_check'] = true;
        this.dataSource['sales_per_employee_check'] = true;
        this.dataSource['fixedAssetsNetWorth_check'] = true;
        this.dataSource['invTurnover_check'] = true;
        this.dataSource['arTurnover_check'] = true;
        this.dataSource['totalAssetTurnover_check'] = true;
        this.dataSource['workingCapitalTurnover_check'] = true;
        this.dataSource['daysWorkingCapital_check'] = true;
        this.dataSource['cashTurnover_check'] = true;
        this.dataSource['efficiency_index_check'] = true;
        this.dataSource['year_0_check'] = true;
        this.dataSource['year_1_check'] = true;
        this.dataSource['year_2_check'] = true;
        this.dataSource['year_3_check'] = true;
        this.dataSource['year_4_check'] = true;
        //this.dataSource['year_5_check'] = true;
        this.dataSource['year_field_0'] = 2020; // TODO: make this automatic.
        this.dataSource['year_field_1'] = 2021; // TODO: make this automatic.
        this.dataSource['year_field_2'] = 2022; // TODO: make this automatic.
        this.dataSource['year_field_3'] = 2023; // TODO: make this automatic.
        this.dataSource['year_field_4'] = 2024; // TODO: make this automatic.
        //this.dataSource['year_field_5'] = 2024; // TODO: make this automatic.
        this.dataSource['pl_balance_percent_check'] = true;
        this.dataSource['pl_balance_dollar_check'] = true;
        this.dataSource['source_uses_check'] = true;
        this.dataSource['ratio_scores_check'] = true;
        this.dataSource['summary_scores_check'] = true;
           
            this.saveInputs()
        },
        saveValuation: function (csvData) {
            let revenue = this.getCSVData(csvData, 6);
            let gross_margin = this.getCSVData(csvData, 8);
            let officers_compensation = this.getCSVData(csvData, 9);
            let salary_wages = this.getCSVData(csvData, 10);
            let rent = this.getCSVData(csvData, 11);
            let taxes_paid = this.getCSVData(csvData, 12);
            let advertising = this.getCSVData(csvData, 13);
            let benefitsPension = this.getCSVData(csvData, 14);
            let repairs = this.getCSVData(csvData, 15);
            let badDebts = this.getCSVData(csvData, 16);
            let salesGeneralAdmin = this.getCSVData(csvData, 17);
            let depreciation = this.getCSVData(csvData, 18);
            let interest_income = this.getCSVData(csvData, 19);
            let interest_expense = this.getCSVData(csvData, 20);
            let other_income = this.getCSVData(csvData, 21);
            let cash = this.getCSVData(csvData, 25);
            let accounts_receivable = this.getCSVData(csvData, 26);
            let inventory = this.getCSVData(csvData, 27);
            let otherCurrentAssets = this.getCSVData(csvData, 28);
            let netFixedAssets = this.getCSVData(csvData, 31);
            let otherNonCurrentAssets = this.getCSVData(csvData, 32);
            let accounts_payable = this.getCSVData(csvData, 34);
            let loan_notes_payable = this.getCSVData(csvData, 35);
            let current_liabilties = this.getCSVData(csvData, 36);
            let long_term_liabilities = this.getCSVData(csvData, 37);
            let ft_emps = this.getCSVData(csvData, 38);
            let avg_annual_wage = this.getCSVData(csvData, 39);

            for (let i = 0; i < this.years; i++) {
                this.params[`revenue${i}`] = revenue[i];
                this.params[`gross_margin${i}`] = gross_margin[i];
                this.params[`officers_compensation${i}`] = officers_compensation[i];
                this.params[`pre_tax_net_profit${i}`] = parseInt(gross_margin[i]) - parseInt(officers_compensation[i]) - parseInt(salary_wages[i]) - parseInt(rent[i]) - parseInt(taxes_paid[i]) - parseInt(salesGeneralAdmin[i]) - parseInt(advertising[i]) - parseInt(benefitsPension[i]) - parseInt(repairs[i]) - parseInt(badDebts[i]) - parseInt(depreciation[i]) + parseInt(interest_income[i]) - parseInt(interest_expense[i]) + parseInt(other_income[i]);
                this.params[`depreciation${i}`] = depreciation[i];
                this.params[`operating_expenses${i}`] = parseInt(officers_compensation[i]) + parseInt(salary_wages[i]) + parseInt(rent[i]) + parseInt(taxes_paid[i]) + parseInt(salesGeneralAdmin[i]) + parseInt(advertising[i]) + parseInt(benefitsPension[i]) + parseInt(repairs[i]) + parseInt(badDebts[i]) + parseInt(depreciation[i]);
                this.params[`interest_expense${i}`] = interest_expense[i];
                this.params[`accounts_receivable${i}`] = accounts_receivable[i];
                this.params[`current_assets${i}`] = parseInt(cash[i]) + parseInt(accounts_receivable[i]) + parseInt(inventory[i]) + parseInt(otherCurrentAssets[i]);
                this.params[`total_assets${i}`] = parseInt(cash[i]) + parseInt(accounts_receivable[i]) + parseInt(inventory[i]) + parseInt(netFixedAssets[i]) + parseInt(otherNonCurrentAssets[i]);
                this.params[`current_liabilties${i}`] = parseInt(accounts_payable[i]) + parseInt(loan_notes_payable[i]) + parseInt(current_liabilties[i]);
                this.params[`long_term_liabilities${i}`] = long_term_liabilities[i];
                this.params[`ft_emps${i}`] = ft_emps[i];
                this.params[`avg_annual_wage${i}`] = avg_annual_wage[i];
                this.params[`accounts_payable${i}`] = accounts_payable[i];
            }
            this.saveInputs()
        },
        fileSelected: async function (event) {
            const files = event.target.files;
            const fileReader = new FileReader();
         
            fileReader.onload = e => {
               let csvData =  e.target.result.split('\r\n')
                switch (this.reportType){
                    case 'market': this.saveMarket(csvData);
                        break;
                    case 'financial': this.saveFinancial(csvData);
                        break;
                    case 'valuation': this.saveValuation(csvData);
                        break;
                    case 'company': this.saveCompany(csvData);
                        break;
                }
            };
            fileReader.readAsText(files[0])
        },

        getCSVData(csvData, row) { 
            if(row == 17)
                return csvData[row]
                    .slice(2, csvData[row].length)
                    .split(',')
                    .slice(-this.years);

            else if(csvData[row].includes('"'))
                return csvData[row].slice(2, csvData[row].length)
                .split('"')
                .slice(1)
                .filter(item=> !(item==',' || item==''))
                .slice(-this.years);
          
            return csvData[row]
                .slice(2, csvData[row].length)
                .split(',')
                .slice(-this.years);
        },

        saveInputs: async function () {
            this.params.action = 'save';
           
           if (this.reportType != 'company' && this.reportType != 'valuation')
                this.params.data = Object.assign({}, this.dataSource);
            this.params.profile_id = this.$route.params.id;
            this.params.report_id = this.$route.params.id;           
            this.params.type = this.checkReport(false);

            await this.save(this.params)
                .then((res) => {
                    this.alertSuccess('Data loaded.');
                    document.location.reload(true);
                })
                .catch((err) => {
                    this.alertError('An error occurred. We have been notified.');
                })
        },
        chooseInputFormat: function () {
            this.$refs.csvInput.click();            
        },    
    },
};
</script>

<style lang="scss">
.search-box input,
.client-name-box input,
.client-name-box textarea {
    width: 100%;
}

.client-name-box>div {
    width: 100%;
}

.upload-modal {
    position: absolute !important;
    background-color: transparent !important;
    top: unset !important;
    bottom: 50px !important;
}
</style>